import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Close, Loader } from "../icons";
import SelectInput from "../common/SelectInput";
import { useGetCampusUsersQuery } from "../../store/api";

export default function AssignCampusRoleModal({
  open,
  onClose,
  campus,
  roleType = "vp",
  onSubmit,
  isLoading = false,
}) {
  const [userId, setUserId] = useState("");

  const { data, isLoading: isLoadingUsers } = useGetCampusUsersQuery(
    campus?.id,
    { skip: !open || !campus?.id },
  );

  const users = data?.data?.users || [];

  useEffect(() => {
    if (!open) {
      setUserId("");
    }
  }, [open]);

  const isVP = roleType === "vp" || roleType === "update_vp";
  const isUpdate = roleType.startsWith("update_");

  const title = isVP
    ? isUpdate ? "Change Vice Principal" : "Assign Vice Principal"
    : isUpdate ? "Change Store Incharge" : "Assign Store Incharge";
  
  const submitLabel = isVP
    ? isUpdate ? "Change VP" : "Assign VP"
    : isUpdate ? "Change Incharge" : "Assign Incharge";

  function handleSubmit() {
    if (!userId) return;
    onSubmit?.({ campusId: campus.id, userId });
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[503px] pt-[30px] pb-[46px] px-0"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center justify-between mb-6 px-9">
          <p className="text-xl font-bold leading-6 text-black">{title}</p>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-4 sm:pt-10 px-9">
          <p className="text-sm text-[#7E7E7E] mb-6">
            Select a user from{" "}
            <span className="font-medium text-black">{campus?.name}</span> to
            {isUpdate ? " change" : " assign as"} {isVP ? "Vice Principal" : "Store Incharge"}.
          </p>

          {isLoadingUsers ? (
            <div className="flex justify-center py-8">
              <Loader />
            </div>
          ) : users.length === 0 ? (
            <p className="text-sm text-[#878686] py-4">
              No users found for this campus. Add users to this campus first.
            </p>
          ) : (
            <SelectInput
              label="Select User"
              options={users.map((user) => ({
                label: `${user.name} (${user.email})`,
                value: user._id,
              }))}
              value={userId}
              onChange={setUserId}
              placeholder="Choose a user"
            />
          )}

          <button
            onClick={handleSubmit}
            disabled={isLoading || !userId || users.length === 0}
            className="w-full mt-8 bg-[#6D4E8A] text-white py-3 font-bold text-sm rounded-[5px] flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {isLoading && <Loader />}
            {isLoading ? (isUpdate ? "Changing..." : "Assigning...") : submitLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
